import React from 'react';
import PropTypes from 'prop-types';

import {Chip, Menu, MenuItem} from 'views/components';
import {translate} from 'views/module';

import {JOB_STATUSES} from 'utils/backend/loom/job/job_adapter';

const STATUS_COLOURS = {
  REVIEW: 'warning',
  ACTIVE: 'success',
  DEACTIVATED: 'default',
};

const JobStatusMenu = (props) => {
  const {status, editable, onChange} = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const select = (next) => {
    setAnchorEl(null);
    if (next !== status) onChange(next);
  };

  return (
    <>
      <Chip
        size='small'
        color={STATUS_COLOURS[status]}
        label={translate(`job.ClientJobs.Status.${status}`)}
        onClick={editable ? (event) => setAnchorEl(event.currentTarget) : undefined}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {
          JOB_STATUSES.map((option) => (
            <MenuItem
              key={option}
              selected={option === status}
              onClick={() => select(option)}
            >
              {translate(`job.ClientJobs.Status.${option}`)}
            </MenuItem>
          ))
        }
      </Menu>
    </>
  );
};

JobStatusMenu.propTypes = {
  status: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(JobStatusMenu);
